<template>
  <main-template>
    <v-row>
      <v-col>
        <h2>
          <v-btn color="primary" x-small text @click="$router.back()">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          DESEMPENHO PEDAGÓGICO - PROFESSOR
          <span class="meu-componente-especial">
            <e-help-tooltip :text="$constants.tooltips.desempenhoPedagogico.desempenhoProfessor" />
          </span>
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          prepend-icon="mdi-school"
          v-model="escola"
          :items="franquias.filter((item) => !item.deleted_at)"
          item-text="descricao"
          item-value="id"
          dense
          return-object
          filled
          color="orange"
          label="Selecione uma escola"
          @change="loadPendenciasProfessores(escola.id)"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row v-if="carregandoUsabilidade">
      <v-col cols="12">
        <div class="text-center mb-4">
          <v-icon color="primary" class="mb-2">mdi-loading mdi-spin</v-icon>
          <p class="text-body-2 text-medium-emphasis">Aguarde, isso pode demorar...</p>
        </div>

        <v-card class="mb-3" v-for="n in 3" :key="n" elevation="1">
          <v-card-text>
            <div class="d-flex align-center mb-3">
              <v-skeleton-loader type="avatar" class="me-3"></v-skeleton-loader>

              <div class="flex-grow-1">
                <v-skeleton-loader type="heading" class="mb-1" width="60%"></v-skeleton-loader>
                <v-skeleton-loader type="subtitle" width="40%"></v-skeleton-loader>
              </div>

              <v-skeleton-loader type="chip" width="80px"></v-skeleton-loader>
            </div>

            <v-skeleton-loader type="paragraph" class="mb-2"></v-skeleton-loader>

            <div class="d-flex justify-end gap-2">
              <v-skeleton-loader type="button" width="80px"></v-skeleton-loader>
              <v-skeleton-loader type="button" width="100px"></v-skeleton-loader>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else-if="professoresAgrupados.length === 0">
      <v-col cols="12">
        <v-alert type="info" text>
          Nenhum dado de desempenho encontrado para a escola selecionada.
        </v-alert>
      </v-col>
    </v-row>

    <div v-else>
      <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
        <v-tab href="#professores">
          <v-icon left>groups</v-icon>
          Desempenho dos Professores
        </v-tab>
        <v-tab href="#relatorios">
          <v-icon left>query_stats</v-icon>
          Relatórios de Desempenho (Professor)
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="mt-4">
        <v-tab-item value="professores">
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-title>
                  <span class="text-h6">Professores:</span>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar Professor"
                    single-line
                    hide-details
                    dense
                    class="ml-4 mt-6 mr-6 mb-3"
                    style="max-width: 350px"
                  >
                  </v-text-field>
                </v-card-title>

                <!-- Lista de professores -->
                <v-card-text>
                  <v-expansion-panels>
                    <professor-expansion-item
                      v-for="professor in professoresPaginados"
                      :key="professor.id"
                      :professor="professor"
                      class="mb-4 gestao-card"
                    />
                  </v-expansion-panels>
                </v-card-text>

                <e-paginate
                  v-if="totalPages > 1"
                  :current_page="currentPage"
                  :last_page="totalPages"
                  :page-number="currentPage"
                  :search="searchTerm"
                  @changeActionResponse="handlePageChange"
                  class="mt-4 mb-4 pagination-fix"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item value="relatorios">
          <v-card>
            <v-card-text class="d-flex justify-start align-center flex-wrap">
              <v-col cols="12" sm="6" md="4">
                <v-card color="primary" @click="DesempenhoProfessorPorFranquia(escola?.id)">
                  <v-card-title>
                    <v-icon large left> groups </v-icon>
                    <span class="title font-weight-light">Relatorio Desempenho</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold">por Unidade Escolar</v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-card color="primary" @click="DesempenhoProfessorPorTurma(escola?.id)">
                  <v-card-title>
                    <v-icon large left> groups </v-icon>
                    <span class="title font-weight-light">Relatorio Desempenho</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold">por Turma</v-card-text>
                </v-card>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <e-modal-turmas-franquia
      :dialog="dialogTurmasFranquia"
      :franquia_id="escola?.id"
      @dialogChange="dialogTurmasFranquia = $event"
      tipo-relatorio="professor"
    ></e-modal-turmas-franquia>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import EPaginate from "@/components/EPaginate.vue";
import ProfessorExpansionItem from "./ProfessorExpansionItem.vue";

export default {
  components: {
    ProfessorExpansionItem,
    EPaginate,
  },

  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquiasList"]),

    professoresAgrupados() {
      if (!this.UsabilidadeList || !this.UsabilidadeList.turmas) {
        return [];
      }

      const professoresMap = new Map();

      this.UsabilidadeList.turmas.forEach((turma) => {
        turma.professores.forEach((professor) => {
          professor.gestoes.forEach((gestao) => {
            const professorNome = professor.nome;

            if (!professoresMap.has(professorNome)) {
              professoresMap.set(professorNome, {
                nome: professorNome,
                gestoes: [],
              });
            }

            professoresMap.get(professorNome).gestoes.push({
              id: gestao.id,
              curso_id: turma.curso_id,
              turma: turma.descricao,
              disciplina_id: gestao.disciplina_id,
              disciplinas_da_gestao: gestao.disciplinas_da_gestao,
              relacaoAulasEtapas: gestao.relacaoAulasEtapas,
              pendencias: gestao.pendencias,
              turma_id: turma.id,
              instrutor_id: gestao.instrutor_id,
              is_polivalencia: gestao.is_polivalencia,
              series_da_turma: turma.series_da_turma.split(",").map((s) => s.trim()),
            });
          });
        });
      });

      return Array.from(professoresMap.values());
    },

    professoresFiltrados() {
      if (!this.search) {
        return this.professoresAgrupados;
      }
      const searchTerm = this.search.toLowerCase().trim();
      return this.professoresAgrupados.filter((professor) =>
        professor.nome.toLowerCase().includes(searchTerm)
      );
    },

    totalProfessores() {
      return this.professoresAgrupados.length;
    },

    totalPages() {
      return Math.ceil(this.totalProfessores / this.itemsPerPage);
    },

    professoresPaginados() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.professoresFiltrados.slice(start, end);
    },
  },

  async mounted() {
    await this.loadData();
    if (this.escola.id) {
      await this.loadPendenciasProfessores(this.escola.id);
    }
  },

  data() {
    return {
      tab: "professores",
      escola: {
        id: null,
        descricao: null,
      },
      UsabilidadeList: [],
      carregandoUsabilidade: false,
      currentPage: 1,
      itemsPerPage: 5,
      search: "",
      searchTerm: "",
      franquias: [],
      podeTrocarFranquia: false,
      dialogTurmasFranquia: false,
    };
  },

  watch: {
    search() {
      this.currentPage = 1;
    },
  },

  methods: {
    async loadData() {
      await this.$services.franquiasService.syncAll();
      this.escola.id = this.user.franquia.id;
      const data1 = this.franquiasList?.map((franq) => {
        if (!this.user.franquias_permitidas) {
          this.franquias = [...this.franquiasList];
        }
        const data2 = this.user.franquias_permitidas?.map((franquiaPermitida) => {
          if (franquiaPermitida === franq.id) {
            this.franquias.push(franq);
          }
        });
      });
    },

    async loadPendenciasProfessores(escolaId) {
      if (!escolaId) return;

      this.carregandoUsabilidade = true;
      try {
        const response = await this.$services.usabilidadeService.getProfessoresUsabilidade(
          escolaId
        );
        this.UsabilidadeList = response;
        this.currentPage = 1;
        this.search = "";
      } catch (error) {
        this.UsabilidadeList = [];
        this.$handleError(error);
      } finally {
        this.carregandoUsabilidade = false;
      }
    },

    handlePageChange(page, searchTerm) {
      this.currentPage = page;
      this.searchTerm = searchTerm;
    },

    async DesempenhoProfessorPorFranquia(escolaId) {
      this.$loaderService.open("Carregando dados... Isso pode demorar um pouco.");
      await this.$services.relatoriosService.DesempenhoProfessorPorFranquia(escolaId);
      this.$loaderService.close();
    },

    async DesempenhoProfessorPorTurma(escolaId) {
      try {
        this.franquia_id = escolaId;
        this.dialogTurmasFranquia = !this.dialogTurmasFranquia;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  min-height: 48px;
}

.v-card {
  height: 100%;
  transition: all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 8px !important;
  overflow: hidden;
  border-left: 4px solid transparent;
}

.v-card.primary {
  border-left-color: var(--v-primary-base);
  background: linear-gradient(to right, #fff7e4, #ffffff);
}

.v-card.success {
  border-left-color: var(--v-success-base);
  background: linear-gradient(to right, #f0fff0, #ffffff);
}

.v-tabs {
  border-radius: 8px;
}

.v-tab {
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.v-tab--active {
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.062);
}

.v-tab-item {
  padding: 8px 0;
}

.v-col {
  padding-bottom: 16px;
  padding-top: 8px;
}

@media (max-width: 960px) {
  .v-card__title {
    font-size: 1rem !important;
    padding: 12px !important;
  }

  .v-card__text {
    font-size: 0.875rem !important;
    padding: 0 12px 12px !important;
  }

  .v-tab {
    font-size: 0.75rem;
    min-width: auto;
    padding: 0 12px;
  }

  .v-tab .v-icon {
    font-size: 1.25rem !important;
    margin-right: 4px !important;
  }
}

.v-card:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.3s;
}

.v-card:hover:before {
  opacity: 0.04;
}

.v-autocomplete {
  border-radius: 8px;
  overflow: hidden;
}

.v-row:not(:last-child) {
  margin-bottom: 16px;
}

.pagination-fix {
  position: relative;
  z-index: 1;
}
</style>
